export default __webpack_public_path__ + "static/media/sima.7ee72137.jpg";